import { useDelete } from '@refinedev/core';

export function useDeleteFund() {
  const { mutateAsync, error, isLoading, reset } = useDelete();

  const deleteFund = async (id: string) => {
    return mutateAsync({
      resource: 'funds',
      id,
    });
  };

  return {
    deleteFund,
    error,
    isLoading,
    reset,
  };
}
